import { Component } from '@angular/core';

@Component({
    selector: 'app-root-auth',
    templateUrl: './auth-root.component.html',
    styleUrls: ['./auth-root.component.scss'],
})
export class AuthRootComponent {
}
